export class PushCartRecommendationsPriceSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    if (this.els.switcher?.exists && this.externalEls.value?.exists) {
      this.els.switcher.element.addEventListener(
        'change',
        this.handleVariantChange.bind(this),
      )
    }
  }

  handleVariantChange (e) {
    const currentVariantId = e.currentTarget.value
    const currentSelectedOption = e.currentTarget.querySelector(
      `option[value='${currentVariantId}']`,
    )
    const currentPrice = currentSelectedOption.dataset.price

    this.closest('product-form').querySelector(
      this.externalEls.value.selector,
    ).innerHTML = currentPrice
  }
}

if (!customElements.get('push-cart-recommendations-price-switcher')) {
  customElements.define(
    'push-cart-recommendations-price-switcher',
    PushCartRecommendationsPriceSwitcher,
  )
}
